import Image from 'next/image'
import {
  PortableText,
  PortableTextBlock,
  PortableTextBlockComponent,
} from '@portabletext/react'
import { getAdvertorialAttributeByCard, nextImageHelper } from '../../utils'
import { CompareCredit } from '../../../types'

const Normal: PortableTextBlockComponent = ({
  children,
}: React.PropsWithChildren) => <p>{children}</p>

const AttributeRenderer = (
  referencedCards: null | Record<string, CompareCredit.Entity>,
) => {
  const render: React.FC<{
    value: { attribute: string; bonusRewards: string; cards: { _ref: string } }
  }> = ({ value: { attribute, bonusRewards, cards } }) => {
    if (!referencedCards) {
      return <></>
    }
    const card = Object.values(referencedCards).find(
      (referencedCard) => referencedCard._id === cards._ref,
    ) as CompareCredit.FormattedCard
    return getAdvertorialAttributeByCard({
      card,
      attribute,
      bonusRewards,
    })
  }
  return render
}

export const WhatIsBT = (data: {
  referencedCards: null | Record<string, CompareCredit.Entity>
}) => {
  const render: React.FC<{
    value: { title: string; description: PortableTextBlock[] }
  }> = ({ value: { title, description } }) => {
    const { referencedCards } = data

    return (
      <div className="c-whatis-bt / bg-white text-center text-slate-700 mt-4 mb-8 / leading-[1.3]">
        <h2 className="c-whatis-bt__title / text-lg sm:text-xl md:text-2xl font-bold mb-2">
          {title}
        </h2>
        <div className="c-whatis-bt__content / text-slate-700 text-sm mb-3">
          <PortableText
            value={description}
            components={{
              block: {
                normal: Normal,
              },
              types: {
                advertorialAttribute: AttributeRenderer(referencedCards),
              },
            }}
          />
        </div>
        <ul className="c-whatis-bt__list / inline-block / sm:grid sm:grid-cols-3 sm:gap-4 / w-auto / text-base text-slate-700">
          <li className="flex sm:flex-col flex-row items-center gap-4 sm:gap-1 md:gap-3 / mb-2 sm:mb-0">
            <div className="shrink-0 / w-9 md:w-10">
              <Image
                alt="what is balance transfer save on interest"
                src="/static/icons/what-is-balance-transfer-save-on-interest.svg"
                height={36}
                width={36}
                aria-hidden={true}
                style={nextImageHelper.responsive}
              />
            </div>
            <strong>Save on&nbsp;interest</strong>
          </li>
          <li className="flex sm:flex-col flex-row items-center gap-4 sm:gap-1 md:gap-3 / mb-2 sm:mb-0">
            <div className="shrink-0 / w-9 md:w-10">
              <Image
                alt="what is balance transfer pay off debt"
                src="/static/icons/what-is-balance-transfer-pay-off-debt.svg"
                height={36}
                width={36}
                aria-hidden={true}
                style={nextImageHelper.responsive}
              />
            </div>
            <strong>Pay off debt&nbsp;faster</strong>
          </li>
          <li className="flex sm:flex-col flex-row items-center gap-4 sm:gap-1 md:gap-3 / mb-2 sm:mb-0">
            <div className="shrink-0 / w-9 md:w-10">
              <Image
                alt="what is balance transfer no fee"
                src="/static/icons/what-is-balance-transfer-no-fee-dollar.svg"
                height={36}
                width={36}
                aria-hidden={true}
                style={nextImageHelper.responsive}
              />
            </div>
            <strong>Start Without Spending</strong>
          </li>
        </ul>
      </div>
    )
  }
  return render
}
